import { useRuleConflictPreview } from "components/modals/RuleConflictWarningModal";
import { getWorkingHoursConflictPreview } from "hooks/mutations/staff";
import { SetWorkingHoursForm } from "shared/types";

/**
 * Gates a working-hours save (InstructorWorkingHours.tsx) behind a preview
 * of which of that instructor's near-future classes would newly fall
 * outside the PROPOSED hours, and offers "Hapus Kelas & Simpan" to delete
 * them with the save. Thin wrapper over useRuleConflictPreview
 * (RuleConflictWarningModal.tsx), which the class-assignment gate shares.
 */
export const useWorkingHoursPreview = () => {
  const { checkAndConfirm, warning } = useRuleConflictPreview<SetWorkingHoursForm>(
    getWorkingHoursConflictPreview,
    "working_hours_conflict",
  );
  return { checkAndConfirm, workingHoursPreviewWarning: warning };
};
